export default __webpack_public_path__ + "static/media/ic-hyperlink.7fffd1d6.svg";